import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import * as usuariosApi from '../../api/usuarios';
import { useAuth } from '../../contexts/AuthContext';
import { useEmpresaSelecionada } from '../../contexts/EmpresaContext';
import PageHeader from '../../components/common/PageHeader';
import SearchableSelect from '../../components/common/SearchableSelect';
import { getErrorMessage } from '../../utils/apiError';

const PERFIS_POR_ATOR = {
  super_admin: [
    { value: 'operador', label: 'Operador' },
    { value: 'admin', label: 'Admin' },
    { value: 'super_admin', label: 'Super Admin' },
  ],
  admin: [{ value: 'operador', label: 'Operador' }],
};

export default function UsuarioForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const editando = Boolean(id);
  const isSuperAdmin = user?.perfil === 'super_admin';
  const { empresas } = useEmpresaSelecionada();

  const [form, setForm] = useState({ nome: '', email: '', perfil: 'operador', senha: '', id_empresa: '' });
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  const precisaEmpresa = isSuperAdmin && form.perfil !== 'super_admin' && !editando;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    if (precisaEmpresa && !form.id_empresa) {
      setErro('Selecione a empresa do usuário.');
      return;
    }
    setSalvando(true);
    try {
      if (editando) {
        const { senha, email, id_empresa, ...resto } = form;
        await usuariosApi.updateUsuario(id, senha ? { ...resto, senha } : resto);
      } else {
        await usuariosApi.createUsuario(form);
      }
      navigate('/usuarios');
    } catch (err) {
      setErro(getErrorMessage(err, 'Erro ao salvar usuário.'));
    } finally {
      setSalvando(false);
    }
  };

  const opcoesPerfil = PERFIS_POR_ATOR[user?.perfil] || PERFIS_POR_ATOR.admin;

  return (
    <div>
      <PageHeader titulo={editando ? 'Editar usuário' : 'Novo usuário'} />
      <form onSubmit={handleSubmit} className="sf-card p-4" style={{ maxWidth: 560 }}>
        {erro && (
          <div className="sf-login-alert mb-3">
            <i className="bi bi-exclamation-circle" />
            {erro}
          </div>
        )}

        <label className="sf-field-label mb-3">
          <span>Nome</span>
          <span className="sf-field">
            <i className="bi bi-person" />
            <input required value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} />
          </span>
        </label>

        {!editando && (
          <label className="sf-field-label mb-3">
            <span>E-mail</span>
            <span className="sf-field">
              <i className="bi bi-envelope" />
              <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            </span>
          </label>
        )}

        <label className="sf-field-label mb-3">
          <span>Perfil</span>
          <select className="form-select" value={form.perfil} onChange={(e) => setForm({ ...form, perfil: e.target.value })}>
            {opcoesPerfil.map((p) => (
              <option key={p.value} value={p.value}>{p.label}</option>
            ))}
          </select>
        </label>

        {precisaEmpresa && (
          <label className="sf-field-label mb-3">
            <span>Empresa</span>
            <SearchableSelect
              options={empresas.map((e) => ({ value: e.id_empresa, label: e.nome }))}
              value={form.id_empresa}
              onChange={(v) => setForm({ ...form, id_empresa: v })}
              placeholder="Selecione a empresa..."
              required
            />
          </label>
        )}

        <label className="sf-field-label mb-3">
          <span>{editando ? 'Nova senha (deixe em branco para manter)' : 'Senha (mínimo 8 caracteres)'}</span>
          <span className="sf-field">
            <i className="bi bi-lock" />
            <input
              type="password"
              required={!editando}
              minLength={8}
              value={form.senha}
              onChange={(e) => setForm({ ...form, senha: e.target.value })}
            />
          </span>
        </label>

        <button type="submit" className="sf-btn sf-btn-primary" disabled={salvando}>
          {salvando ? 'Salvando...' : 'Salvar'}
        </button>
      </form>
    </div>
  );
}
